import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagFacilitatorProps {}

const ColorTagFacilitator: React.FC<ColorTagFacilitatorProps> = props => {
  return <ColorTag className="ColorTagFacilitator" color="blueGreen" appearance="translucent">Facilitator</ColorTag>
}

export default ColorTagFacilitator;